<template>
  <!-- 横向商品 -->
  <div class="order-block">
    <div class="order-top" @click="goOrderDetails">
      <span class="order-time">订单编号：{{ info.order_sn }}</span>

      <span class="order-type">{{ info.order_status_name }}</span>
    </div>

    <div class="img-text-row" v-for="(item, index) in info.goods" :key="index" @click="goOrderDetails">
      <div class="row-goods-img">
        <img :src="item.goods_pic" alt="" />
      </div>

      <div class="row-goods-info">
        <!-- <p class="row-goods-leble">
          <span class="rx">热销</span> <span class="xs">热销</span>
        </p> -->
        <p class="row-goods-name van-multi-ellipsis--l2">
          {{item.goods_name}}
        </p>
        <p class="row-goods-des">

        </p>
        <p class="row-goods-class"> {{item.sku}}</p>
        <!-- <p class="row-goods-original-price">¥ 360.00</p> -->
        <p class="row-goods-price">
          共 {{item.goods_num}}件 <span class="price-r-line">¥ {{item.market_price}}</span><span class="price-r">¥ {{item.goods_price}}</span>
        </p>
      </div>
    </div>

    <div class="total-money">
      <span class="number mr10">总计：￥{{info.total_amount}}</span>
      <!-- <span class="number mr10">运费￥{{info.expressFee}}</span> -->
      <span>实付</span>
      <span>￥<span class="total-money-price">{{info.order_amount}}</span></span>
     
    </div>

    <div class="foot-btn-block"> 
      <!-- <div class="btn click" @click="onClickRight">联系我们</div> -->

      <div class="btn btnf  click" v-if="info.button_pay == 1" @click="goPayresult(info)">立即支付</div>
      <div class="btn btns click" v-if="info.button_cancel == 1" @click="cancelOrder(info)">取消订单</div>
      <div class="btn btns click" v-if="info.button_delete == 1" @click="deleteOrder(info)">删除订单</div>
      <!-- <div class="btn btns click" v-if="info.button_confirm == 1"  @click="confirmOrder(info)">确认收货</div>  -->
      <!-- <div class="btn btnf click" v-if="info.button_comment == 1" @click="goPage({name:'comment-in',query:{id:info.state}})">评价订单</div> -->

      <!-- <div class="btn btnf click" @click="goPage({name:'order-express',query:{id:info.state}})">查看物流</div> -->
      <!-- <div class="btn click" @click="goPage({name:'order-after',query:{id:info.state}})">申请售后</div> -->

      <!-- <div class="btn btnf click" v-if="info.pay_status == 1 && time == 0" @click="remind">提醒发货</div>
      <div class="btn btnf op" v-if="info.pay_status == 1 && time > 0">{{ time }}</div> -->
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  name: "imgTextRow",
  props: {
    info: {
      type: Object,
      default: {
        order_sn: "订单编号",
        total_amount: "总金额",
        order_amount: "应付金额（线上支付）",
        pay_status: "支付状态 0=未支付 1=已支付",
        order_status: "订单状态值",
        created_time: "创建时间",
        user_delete: "",
        order_type: "订单类型",
        order_status_name: "订单状态",
        button_cancel: "1显示取消订单按钮",
        button_delete: "1显示删除订单按钮",
        button_confirm: "1显示确认收货订单按钮",
        button_pay: "1显示支付按钮",
        button_comment: "1显示评价按钮",
        goods: [
          {
            goods_id: "商品id",
            goods_name: "商品名称",
            goods_pic: "图片",
            goods_num: "购买数量",
            goods_price: "销售价格",
            market_price: "市场价格",
          },
        ],
      },
    },
  },
  components: {},
  data() {
    return {
      time: 0,
      currentTime: 20,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 提醒发货
    remind() {
      var that = this;
      var currentTime = that.currentTime;
      this.$toast({
        message: "已提醒商家~",
      });
      that.time = currentTime;

      let interval = setInterval(function () {
        that.time = currentTime - 1;
        currentTime--;
        if (currentTime <= 0) {
          clearInterval(interval);
          that.time = 0;
          that.currentTime = 20;
        }
      }, 1000);
    },
    onClickRight() {
      this.MakeCall(); //拨打电话
    },
    goOrderDetails() {
      this.$router.push({
        name: "order-details",
        query: {
          order_sn: this.info.order_sn,
        },
      });
    },
    // 取消订单
    cancelOrder(info) {
      let _this = this;
      // console.log(info)
      this.$dialog
        .confirm({
          message: "是否取消该订单？",
          confirmButtonText: "是的",
          cancelButtonText: "再想想",
        })
        .then(() => {
          // on confirm
          this.$emit("cancel_order", info);
        })
        .catch(() => {
          // on cancel
        });
    },
    // 删除订单
    deleteOrder(info) {
      let _this = this;
      // console.log(info)
      this.$dialog
        .confirm({
          message: "是否删除该订单？",
          confirmButtonText: "是的",
          cancelButtonText: "再想想",
        })
        .then(() => {
          // on confirm
          this.$emit("delete_order", info);
        })
        .catch(() => {
          // on cancel
        });
    },
    // 确认收货订单
    confirmOrder(info) {
      let _this = this;
      // console.log(info)
      this.$dialog
        .confirm({
          message: "是否确认收货该订单？",
          confirmButtonText: "是的",
          cancelButtonText: "再想想",
        })
        .then(() => {
          // on confirm
          this.$emit("confirm_order", info);
        })
        .catch(() => {
          // on cancel
        });
    },
    // 支付下单
    goPayresult(info) {
      let _this = this; 
      console.log(info)
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      }); 
      let param = {
        order_sn: info.order_sn,
        pay_type:'unionpay',
        wx_openid: Lockr.get("openId"), //微信openid 
      };

      this.$post("/api/order_pay", param, param).then((res) => {
        // console.log(res);
        this.$toast.clear(); //关闭弹窗
        if (res.data.code == 0) {
          console.log(res.data.data, '订单支付')   
          window.location.href = res.data.data.pay;
        } else {
          this.$toast.fail(res.data.message);
        }
      });

      // _this.$toast.fail("支付失败！");
      // _this.$router.replace({
      //   name: "pay-result",
      //   query: {
      //     isType: 2,
      //   },
      // });
      // console.log(info)
      // _this
      //   .$post("/order/api/Pay", {
      //     orderId: info.id,
      //     openId: Lockr.get("openId") || "",
      //   })
      //   .then((res) => {
      //     // console.log(res)
      //     if (res.data.code == 200) {
      //       // console.log(res.data.data.wxParameters)
      //       let wxParameters = res.data.data.wxParameters;
      //       if (wxParameters) {
      //         // 微信支付
      //         _this.payWxPrePay(wxParameters);
      //       } else {
      //         // console.log('积分支付')
      //         _this.$toast.success("支付成功");
      //         _this.$router.replace({
      //           name: "pay-result",
      //           query: {
      //             isType: 1,
      //           },
      //         });
      //       }
      //     } else {
      //       _this.$toast.fail(res.data.message);
      //       _this.$router.replace({
      //         name: "pay-result",
      //         query: {
      //           isType: 2,
      //         },
      //       });
      //     }
      //   })
      //   .catch((err) => {
      //     //console.log(err.data)
      //   });
    },
    // payWxPrePay(data) {
    //   let that = this;
    //   // console.log('吊起微信', data)
    //   // console.log('吊起微信', wx)

    //   //       if (res.err_msg == "get_brand_wcpay_request:ok") {
    //   wx.ready(function () {
    //     wx.chooseWXPay({
    //       timestamp: data.timestamp, ////时间戳，自1970年以来的秒数
    //       nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
    //       package: data.package, //这个package是比较坑的他的格式必须是  prepay_id=wx22104854834640694c34f15a1066605800
    //       signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
    //       paySign: data.paySign, // 支付签名
    //       appId: data.appId, //公众号名称，由商户传入
    //       success: function (res) {
    //         // 支付成功后的回调函数
    //         if (res.errMsg === "chooseWXPay:ok") {
    //           that.$toast("支付成功！");
    //           that.$router.replace({
    //             name: "pay-result",
    //             query: {
    //               isType: 1,
    //             },
    //           });
    //         } else {
    //           // console.log(res, '已调起,支付失败')
    //           that.$toast("支付失败！");
    //           that.$router.replace({
    //             name: "pay-result",
    //             query: {
    //               isType: 2,
    //             },
    //           });
    //         }
    //       },
    //       fail: function (res) {
    //         // console.log(res, '支付请求失败')
    //         that.$toast("支付请求失败");
    //         that.$router.replace({
    //           name: "pay-result",
    //           query: {
    //             isType: 2,
    //           },
    //         });
    //       },
    //       cancel: function (res) {
    //         // console.log(res, '已调起,已取消支付')
    //         // that.$toast("已调起,已取消支付");
    //         that.$toast("已取消支付！");
    //       },
    //     });
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.order-block {
  // background-color: peachpuff;

  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(69, 79, 99, 0.06);
  opacity: 1;
  border-radius: 3px;

  margin: 10px 0;

  .order-top {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .order-time {
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 17px;
    color: #78849e;
  }
  .order-type {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ff5000;
  }
}

// 横向
.img-text-row {
  //   width: 100%;
  box-sizing: border-box;
  //   height: 150px;
  border-bottom: 1px solid #eeeeee;
  //   background-color: #fff;
  //    background-color: palegoldenrod;
  //   margin-bottom: 5px;
  margin: 5px 10px;
  //   padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .row-goods-img {
    width: 125px;
    height: 125px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .row-goods-info {
    width: 200px;
    height: 100%;
    padding: 5px 0;
    text-align: left;
    //  background-color: paleturquoise;

    .row-goods-leble {
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #ffffff;
      letter-spacing: 1px;
      text-align: left;

      span {
        padding: 1px 7px;
        border-radius: 3px;
      }

      .rx {
        background-color: #e95970;
      }
      .xs {
        margin-left: 3px;
        background-color: #b80009;
      }
    }
    .row-goods-name {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #454f63;

      letter-spacing: 1px;
      // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
      // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
      // overflow: hidden; /*超出的文本隐藏*/
      // text-overflow: ellipsis; /* 溢出用省略号*/
      // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
    }
    .row-goods-des {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #78849e;
      letter-spacing: 1px;
      display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
      -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
      overflow: hidden; /*超出的文本隐藏*/
      text-overflow: ellipsis; /* 溢出用省略号*/
      -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
    }
    .row-goods-class {
      display: inline-block;
      background: #f9f9f9;
      opacity: 1;
      border-radius: 3px;
      padding: 2px 5px;
      letter-spacing: 1px;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #bbbbbb;
    }
    .row-goods-original-price {
      text-decoration: line-through;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #cccccc;
    }
    .row-goods-price {
      margin-top: 20px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #999999;
      //   display: flex;
      //   justify-content: space-between;
      //   align-items: center;
      span {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #454f63;
      }
      .price-r {
        float: right;
        color: #ff5000;
      }
      .price-r-line {
        float: right;
        color: #999999;
        margin-left: 10px;
        font-size: 12px;
        text-decoration: line-through;
      }
    }
  }
}

.foot-btn-block {
  padding: 0 10px;
  height: 50px;
  // background-image: url("https://qiniu.zdyxjx.com/minizdyxbg.png");
  // background-repeat: no-repeat;
  // background-size: 65px 55px;
  // background-position: 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  // flex-wrap: wrap;
}
.btn {
  width: 90px;
  height: 25px;
  border: 1px solid #78849e;
  opacity: 1;
  border-radius: 12px;
  margin-left: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 500;

  color: #78849e;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btns {
  border: 1px solid #ff5000;
  color: #ff5000;
}
.btnf {
  border: 1px solid #ff5000;
  background-color: #ff5000;
  color: #fff;
}
.c-btn-class {
  background-color: #e2e8ed !important;
  color: #ff5000 !important;
  opacity: 0.9 !important;
  transform: scale(0.98, 0.98) !important;
}
.op {
  opacity: 0.5 !important;
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}

/* 总金额 */
.total-money {
  text-align: right;
  padding: 5px 10px 0;
  color: #999999;
  font-size: 12px;
}
.total-money-price {
  font-size: 16px;
  color: #78849e;
}
.mr10 {
  margin-right: 10px;
}
</style>
